import common from "./common";
import SplashScene from "./scenes/SplashScene";
import CharacterSelectScene from "./scenes/CharacterSelectScene";
import GameScene from "./scenes/GameScene";
import EndScene from "./scenes/EndScene";
import GameCompleteScene from "./scenes/GameCompleteScene";
import VersusScene from "./scenes/VersusScene";
import UnlockScene from "./scenes/UnlockScene";
import PauseOverlay from "./overlays/PauseOverlay";

export default class Application {
constructor()
    {

    }

init()
    {
        this.showSplashScene();

        //this.showGameCompleteScene();
    }

showSplashScene()
    {
        const scene = new SplashScene();
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.next.add(() =>
            {
                this.showCharacterSelectScene();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showCharacterSelectScene()
    {
        const scene = new CharacterSelectScene();
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.home.add(() =>
            {
                this.showSplashScene();
            }, this),
            scene.signals.next.add(function(characterId)
            {
                common.character = characterId;
                this.showVersusScene();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showVersusScene()
    {
        var playerData = common.config.characters[common.character];
        var enemyData = common.config.characters[common.config.settings.gameFlow.enemyOrder[common.currentBout]];

        const scene = new VersusScene(playerData, enemyData);
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.next.add(function(id)
            {
                this.showGameScene();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showGameScene()
    {
        console.log(common.character);
        console.log(common.config.settings.gameFlow.enemyOrder[common.currentBout]);

        console.log('currentBout:', common.currentBout);
        console.log('currentRound:', common.currentRound);
        console.log('currentScore:', common.currentScores);
        console.log('currentHealth:', common.currentHealth);

        var playerData = common.config.characters[common.character];
        var enemyData = common.config.characters[common.config.settings.gameFlow.enemyOrder[common.currentBout]];

        const scene = new GameScene(playerData, enemyData);
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.previous.add(() =>
            {
                this.showCharacterSelectScene();
            }, this),
            scene.signals.next.add((winner, health) =>
            {
                var thisBout = common.currentBout;
                var newBout = false;
                if(common.currentScores[winner] >= common.config.settings.gameFlow.rounds)
                {
                    common.currentRound = 0;
                    common.currentScores[0] = 0;
                    common.currentScores[1] = 0;
        
                    if(winner == 0)
                    {
                        common.currentBout++;
                    }
                    newBout = true;
                }
                else
                {
                    common.currentRound++;
                }

                common.currentHealth.push(health);

                if(newBout)
                {
                    this.showEndScene(thisBout, winner == 0, common.currentHealth, playerData, enemyData);
                    common.currentHealth = [];
                }
                else
                {
                    this.showGameScene();
                }
            }, this),
            scene.signals.pause.add(() =>
            {
                this.showPauseOverlay();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;
    }

showEndScene(boutNumber, win, healthArr, playerData, enemyData)
    {
        const scene = new EndScene(boutNumber, win, healthArr, playerData, enemyData);
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.home.add(function(){
                this.showSplashScene();
            }, this),
            scene.signals.next.add(function(id, newUnlock)
            {
                var newScene = this.showVersusScene.bind(this);
                if(id == 'charSelect')
                {
                    newScene = this.showCharacterSelectScene.bind(this);
                }
                else if(common.currentBout >= common.config.settings.gameFlow.enemyOrder.length)
                {
                    newScene = this.showGameCompleteScene.bind(this);
                }

                if(newUnlock)
                {
                    this.showUnlockScene(enemyData, newScene);
                }
                else
                {
                    newScene();
                }
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showUnlockScene(charData, newScene)
    {
        const scene = new UnlockScene(charData);
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.next.add(function(id)
            {
                newScene();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showGameCompleteScene()
    {
        const scene = new GameCompleteScene();
        scene.autoAppear = false;

        scene.signalListeners.push(
            
            scene.signals.next.add(function()
            {
                this.showSplashScene();
                this.resetGame();
            }, this)
        );

        this.fadeTransition(() => {
            P3.scene.show(scene);
        }, () => {
            scene.appear();
        });

        common.currentScene = scene;

        return scene;        
    }

showPauseOverlay()
    {
        var prevScene = common.currentScene;
        prevScene.onPause();

        const scene = new PauseOverlay();
        scene.autoAppear = false;

        scene.signalListeners.push(
            scene.signals.home.add(function()
            {
                common.currentRound = 0;
                common.currentScores[0] = 0;
                common.currentScores[1] = 0;
                this.showSplashScene();
            }, this),
            scene.signals.next.add(function(id)
            {
                if(id === 'resume')
                {
                    this.currentScene = prevScene;
                    P3.scene.remove();
                    prevScene.onResume();
                }
                else if(id === 'charSelect')
                {
                    common.currentRound = 0;
                    common.currentScores[0] = 0;
                    common.currentScores[1] = 0;
                    this.showCharacterSelectScene();
                }
                else if(id === 'restart')
                {
                    common.currentRound = 0;
                    common.currentScores[0] = 0;
                    common.currentScores[1] = 0;
                    this.showGameScene();
                }
            }, this)
        );

        P3.scene.add(scene, false);

        this.currentScene = scene;

        return scene;
    }

resetGame()
    {
        common.character = null;
        common.currentBout = 0;
        common.currentRound = 0;
        common.currentScores = {0:0, 1:0};
        common.currentHealth = [];
    }

update()
    {

    }

fadeTransition(a, b, scope)
    {
        scope = scope || window;
        
        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.once(function() {
            transition.out();
            a && a.call(scope);
        }, this);
        transition.signals.out.once(function() {
            transition.destroy();
            b && b.call(scope);
        }, this);
        transition.in();
    }

}